'use strict';

import $ from 'jquery';
import { closelastOpenedComment } from '@/js/application/shoppable-comments';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(() => {
    $(document).on('click', '.shoppable-comment-tab-bar__tab', (e) => {
      const $currentTab = $(e.target);
      if ($currentTab.hasClass('shoppable-comment-tab-bar__tab--selected')) {
        return false;
      }

      const $previousTab = $currentTab.siblings('.shoppable-comment-tab-bar__tab');
      const selectedTabClass = 'shoppable-comment-tab-bar__tab--selected';

      $previousTab.removeClass(selectedTabClass);
      $currentTab.addClass(selectedTabClass);

      const $currentForm = $currentTab
        .parents('.shoppable-comment')
        .find('.shoppable-comment__form.hide');
      const $previousForm = $currentForm.siblings('.shoppable-comment__form').addClass('hide');

      $previousForm.addClass('hide');

      $currentForm.addClass('shoppable-comment__form--active');
      $currentForm.removeClass('hide');
    });
    $(document).on('click', '.discuss-tab-bar__tab', (e) => {
      const $currentTab = $(e.target);
      if ($currentTab.hasClass('discuss-tab-bar__tab--selected')) {
        return false;
      }

      const $previousTab = $currentTab.siblings('.discuss-tab-bar__tab');
      const selectedTabClass = 'discuss-tab-bar__tab--selected';

      $previousTab.removeClass(selectedTabClass);
      $currentTab.addClass(selectedTabClass);

      const $currentForm = $currentTab.parents('.discuss').find('.discuss__form.hide');
      const $previousForm = $currentForm.siblings('.discuss__form');

      $previousForm.addClass('hide');

      $currentForm.removeClass('hide');
    });
  });

  $(document).on('click', '.discuss-without-kind', (e) => {
    $(e.target).hide();
  });
  $(document).on('click', '.discuss-with-kind, .discuss-without-kind', () => {
    const $lastOpenedComment = $('.discuss__comments-container').find('.comment--opened');

    // closing last board comment that is in edit state
    closelastOpenedComment($lastOpenedComment);
  });

  $(document).on('click', '.shoppable-comment-without-kind', (e) => {
    $(e.target).hide();
    const $lastOpenedComment = $('.shoppable-comment__comments-container').find('.comment--opened');

    // closing last shoppable comment that is in edit state
    closelastOpenedComment($lastOpenedComment);
  });
});
